<template>
  <div class="game-container" v-scroll-lock="true">
    <div class="header">
      <span>SELECT GAME</span>
      <img
        class="close"
        src="../../../assets/images/icons/close-white.svg"
        alt="close"
        @click="setShowGameContainer(false)"
      />
    </div>
    <h1 class="title">BROWSE GAMES</h1>
    <section class="tabs">
      <div
        @click="selectedTab = 'all game'"
        :class="{ 'selected-tab': selectedTab === 'all game' }"
      >
        All Games
      </div>
      <div
        v-if="getUser"
        @click="selectedTab = 'favorites'"
        :class="{ 'selected-tab': selectedTab === 'favorites' }"
      >
        Favorites ({{ FavoriteGamesCounter }})
      </div>
    </section>
    <AllGames v-if="selectedTab === 'all game'" :allGames="allGames" />
    <FavoriteGames v-else-if="getUser" :allGames="allGames" />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex"

import AllGames from "./AllGames"
import FavoriteGames from "./FavoriteGames"

export default {
  components: {
    AllGames,
    FavoriteGames,
  },
  data: () => ({
    selectedTab: "all game",
  }),
  computed: {
    ...mapGetters("User", ["getUser", "isUserPro", "activeGames"]),
    ...mapGetters("Game", ["gamePortraitByKey", "pgGames"]),
    allGames () {
      if (!this.pgGames) {
        return []
      }
      const games = []
      for (let game of this.pgGames) {
        if (game.status === "available") {
          const parsedGame = {
            key: game.key,
            name: game.name,
            coverImage: this.gamePortraitByKey(game.key),
            courses: game.resource_metadata.courses,
            active: this.activeGames[game.key]
              ? this.activeGames[game.key].active
              : 0,
          }

          games.push(parsedGame)
        }
      }
      return games
    },
    FavoriteGamesCounter () {
      let counter = 0
      for (let game of this.allGames) {
        if (game.active) {
          counter++
        }
      }
      return counter
    },
  },
  methods: {
    ...mapMutations("Util", ["setShowGameContainer"]),
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_mixins.scss";
.game-container {
  overflow: auto;
  background-color: #27272a;
  z-index: 20;
  top: 5.5rem;
  left: 0;
  bottom: 0;
  right: 0;
  position: fixed;
  text-align: left;
  padding: 4rem 7rem;
  transform-origin: top;
  @include desktop-down {
    top: 0;
    padding: 2rem;
    transform-origin: 50% 20%;
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1rem;
    font-family: Proxima Nova;
    font-weight: 600;
    font-size: 2rem;
    color: #fff;
    @include desktop-large {
      display: none;
    }
    .close {
      height: 2rem;
    }
  }

  .title {
    font-family: Proxima Nova;
    font-weight: 700;
    font-size: 5rem;
    color: #fff;
    @include desktop-down {
      font-size: 3rem;
      margin-bottom: 2rem;
    }
  }

  .tabs {
    display: flex;
    & > div {
      font-family: Proxima Nova;
      margin-right: 2.5rem;
      cursor: pointer;
      font-weight: 700;
      font-size: 2rem;
      opacity: 0.6;
      padding-bottom: 0.7rem;
      margin-right: 2.5rem;
      border-bottom: solid 0.2rem transparent;
      color: #fff;
    }
    .selected-tab {
      border-bottom-color: white;
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/game/GameContainer.vue